<template>
    <a-cascader
        v-model="changeValue"
        :options="options"
        :fieldNames="fieldNames"
        :allowClear="parameters.clearable"
        :showSearch="isShowSearch"
        :placeholder="parameters.placeholder"
        @change="onChange">
        <!-- :show-search="{ filter }" -->
    </a-cascader>
</template>

<script>
import { getRegionTreeList } from "@/api/manage";
import { isMobile } from "@/utils/index";
import store from "@/store";

export default {
    name: "SdRegion",
    props: {
        value: {
            // type: [ String, Number ],
            required: true,
        },
        field: {
            type: Object,
            required: true,
        },
    },
    data() {
        return {
            fieldNames: {
                label: "name",
                value: "code",
                children: "children",
            },
            // 省市区数据项
            regionOptions: [],
            // 选中值
            changeValue: [],
            isShowSearch: true,
        };
    },
    watch: {
        value: {
            handler(newVal, oldVal) {
                if (newVal && this.changeValue.length === 0) {
                    let changeValue = [];
                    let values = [];
                    try {
                        values = JSON.parse(newVal);
                        values.forEach((item) => {
                            item.code && changeValue.push(item.code);
                        });
                        this.changeValue = changeValue;
                    } catch (e) {
                        // eslint-disable-next-line no-empty
                        this.changeValue = changeValue;
                    }
                } else if (!newVal && oldVal) {
                    this.changeValue = [];
                }
            },
            immediate: true,
        },
    },
    computed: {
        // 是否可编辑
        isModify({ $props }) {
            return Boolean($props.field.isModify);
        },
        // data-entry组件参数
        parameters({ $props, $data }) {
            const parameters = $props.field.commonProperties ? JSON.parse($props.field.commonProperties).options : {};
            if (!$props.value && $data.changeValue.length === 0 && parameters.defaultValue) {
                $data.changeValue = parameters.defaultValue;
                this.$emit("update:value", $data.changeValue[$data.changeValue.length - 1]);
            }
            return parameters;
        },
        options({ $data, parameters }) {
            // console.log(82, $data, parameters);
            if (Number(parameters.format) === 3) {
                // console.log(84, $data.regionOptions);
                return $data.regionOptions;
            } else if (Number(parameters.format) === 2) {
                const options = $data.regionOptions;
                options.forEach((item) => {
                    if (item.children.length) {
                        item.children.forEach((child) => {
                            child.children = [];
                        });
                    }
                });
                return options;
            } else if (Number(parameters.format) === 1) {
                const options = $data.regionOptions;
                options.forEach((item) => {
                    item.children = [];
                });
                return options;
            } else {
                return [];
            }
        },
    },
    created() {
        this.isShowSearch = isMobile() ? false : true;
        this.initOptions();
    },
    methods: {
        initOptions() {
            let params = {
                tenantId: store.getters.tenantId,
            };
            // console.log(115, params);
            getRegionTreeList(false, params).then((res) => {
                console.log(117, res);
                this.regionOptions = res || [];
                console.log(118, this.regionOptions);
            });
        },
        onChange(value, selectedOptions) {
            const options = [];
            console.log(120, selectedOptions, value);
            if (selectedOptions) {
                selectedOptions.forEach((item, index) => {
                    options.push({
                        code: item.code,
                        name: item.name,
                        level: index + 1,
                    });
                });
            }

            this.$emit("update:value", JSON.stringify(options));
        },
        // 检索
        // filter(inputValue, path) {
        //     return path.some((option) => option[this.fieldNames.label].indexOf(inputValue) > -1)
        // },
    },
};
</script>

<style scoped lang="less"></style>
